import React from 'react';

import Tag from 'antd/es/tag';

import LinkWithPrevLocation from '@common/react/components/UI/LinkWithPrevLocation/LinkWithPrevLocation';
import { getGoogleMapLink } from '@common/react/components/google/googleUtils';

import { solveWorkingHours } from '@commonTuna/react/utils/workingHours/workingHours';
import { numberWithComma } from '@commonTuna/react/utils/NumberWithComma/NumberWithComma';

import { getLocationAddress, showTime } from '@app/utils/Utils';
import Stars from '@app/components/UI/Stars/Stars';
import ShowPhone from '@app/components/UI/ShowPhone/ShowPhone';
import Rate from '@app/components/Pages/Doctor/Rate';

interface LocationNodeProps {
	item: any;
	hideLink?: boolean;
	addressAsLink?: boolean;
	showRate?: boolean;
}

const LocationInfo: React.FC<LocationNodeProps> = ({
	item, hideLink, addressAsLink, showRate,
}) => {
	const address = React.useMemo(() => getLocationAddress(item), []);
	const link = React.useMemo(() => {
		return getGoogleMapLink(address);
	}, [item]);

	const workingHours = React.useMemo(() => {
		if (!item.workingHours) return [];
		return solveWorkingHours(item.workingHours);
	}, [item.workingHours]);

	return <div className="clearfix">
		{showRate ? <Rate
			averageReviewRate={item.averageReviewRate}
			totalReviewCount={item.totalReviewCount}
			className="stars pull-right ml10"
		/> : null}
		{address ? <span style={{ lineHeight: showRate ? '28px' : undefined }}>
			<strong>
				Address:&nbsp;
			</strong>
			{addressAsLink ? <a style={{ cursor: 'pointer' }} href={link}>{address}</a> : address}
		</span> : null}
		{workingHours.length ? <>
			<br />
			<strong>
				Working Hours:&nbsp;
			</strong>
			{workingHours.map((wh) => <React.Fragment
				key={wh.id}
			>
				<Tag color="orange">
					<strong>
						{wh.title}
						:
					</strong>
					{' '}
					{showTime(wh.startTime)}
					{' '}
					-
					{' '}
					{showTime(wh.endTime)}
				</Tag>
			</React.Fragment>)}
		</> : null}
		{hideLink && !item.showPhone ? null : <div className="pull-right">
			{item.showPhone && <ShowPhone phone={item.phone} location={item} />}
			{!hideLink && <LinkWithPrevLocation
				className="btn btn-sm btn-primary pull-right"
				to={{
					pathname: `/clinics/${item.portalPathEn}`,
				}}
			>
				More About
			</LinkWithPrevLocation>}
		</div>}
	</div>;
};

export default LocationInfo;
